import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
  {
    path: '/dashboard/home',
    title: 'Dashboard',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'dashboard',
    permiso: ['ADM','TRA','VEN'],
    submenu:[]
  },
  {
    path: '/inventario/invent',
    title: 'Inventario',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'book',
    permiso: ['ADM','TRA','VEN'],
    submenu:[]
  },
  {
    path: '/empleado/empleados',
    title: 'Empleados',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'usergroup-add',
    permiso: ['ADM'],
    submenu:[]
  },
  {
    path: '/cita/citas',
    title: 'Citas',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'reconciliation',
    permiso: ['ADM','TRA','VEN'],
    submenu:[]
  },
  {
    path: '/cliente/clientes',
    title: 'Clientes',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user-switch',
    permiso: ['ADM','VEN'],
    submenu:[]
  },
  {
    path: '/pedido/pedi/list',
    title: 'Pedidos',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'shopping',
    permiso: ['ADM','VEN'],
    submenu:[]
  },
];
